import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["iconName"];
import PropTypes from 'prop-types';
import UIIcon from '../icon/UIIcon';
import UIIconButton from './UIIconButton';
import omit from '../utils/underscore/omit';
import { hidden } from '../utils/propTypes/decorators';
import { jsx as _jsx } from "react/jsx-runtime";
const EXCLUDED_ICON_BUTTON_PROP_NAMES = ['children', 'use', 'truncate', 'truncateStringProps'];
const ICON_NAMES = {
  first: 'first',
  previous: 'left',
  next: 'right',
  last: 'last'
};
export default function UIStepperButton(_ref) {
  let {
      iconName
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(UIIconButton, Object.assign({}, rest, {
    use: "tertiary-light",
    children: /*#__PURE__*/_jsx(UIIcon, {
      name: ICON_NAMES[iconName]
    })
  }));
}
UIStepperButton.propTypes = Object.assign({}, omit(UIIconButton.propTypes, EXCLUDED_ICON_BUTTON_PROP_NAMES), {
  'aria-label': PropTypes.string.isRequired,
  active: hidden(PropTypes.bool),
  iconName: PropTypes.oneOf(Object.keys(ICON_NAMES)).isRequired
});

/* eslint-disable-next-line hubspot-dev/no-default-props-assignment */
UIStepperButton.defaultProps = Object.assign({}, omit(UIIconButton.defaultProps, EXCLUDED_ICON_BUTTON_PROP_NAMES));
UIStepperButton.displayName = 'UIStepperButton';